/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Filter_Type_AllInputs */

const en_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Types`)
};

const fr_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les types`)
};

const de_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Arten`)
};

const it_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i tipi`)
};

const ru_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все типы`)
};

const es_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los tipos`)
};

const zh_cn2_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有类型`)
};

const ja_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのタイプ`)
};

const hi_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी प्रकार`)
};

const pt_pt2_manual_qc_filter_type_all = /** @type {(inputs: Manual_Qc_Filter_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os tipos`)
};

/**
* | output |
* | --- |
* | "All Types" |
*
* @param {Manual_Qc_Filter_Type_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_filter_type_all = /** @type {((inputs?: Manual_Qc_Filter_Type_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Filter_Type_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_filter_type_all(inputs)
	if (locale === "de") return de_manual_qc_filter_type_all(inputs)
	if (locale === "it") return it_manual_qc_filter_type_all(inputs)
	if (locale === "ru") return ru_manual_qc_filter_type_all(inputs)
	if (locale === "es") return es_manual_qc_filter_type_all(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_filter_type_all(inputs)
	if (locale === "ja") return ja_manual_qc_filter_type_all(inputs)
	if (locale === "hi") return hi_manual_qc_filter_type_all(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_filter_type_all(inputs)
	return en_manual_qc_filter_type_all(inputs)
});